import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import CategoryCard from './CategoryCard';
import VotingProgressBar from './VotingProgressBar';
export default class VotingView extends Component {
  getVotedCategoryIds(categories) {
    const currentUserId = app.session.user?.id();
    const userVotes = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      return !vUserId || String(vUserId) === String(currentUserId);
    });
    const votedCategoryIds = [];
    categories.forEach(category => {
      const categoryId = category.id();
      const hasVote = userVotes.some(v => {
        const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
        return String(vCategoryId) === String(categoryId);
      });
      if (hasVote) {
        votedCategoryIds.push(String(categoryId));
      }
    });
    return votedCategoryIds;
  }
  view() {
    const award = this.attrs.award;
    const selectedCategoryId = this.attrs.selectedCategoryId;
    const onCategoryChange = this.attrs.onCategoryChange;
    const allCategories = award.categories() || [];

    // Filter categories if a specific category is selected
    const categories = selectedCategoryId ? allCategories.filter(cat => String(cat.id()) === selectedCategoryId) : allCategories;

    // Calculate voting progress
    const votedCategoryIds = this.getVotedCategoryIds(allCategories);
    const totalCategories = allCategories.length;
    const votedCount = votedCategoryIds.length;

    // Get ordered category IDs for navigation
    const categoryIds = allCategories.map(cat => String(cat.id()));
    return m("div", {
      className: "VotingView"
    }, m("div", {
      className: "VotingView-content"
    }, categories.length === 0 ? m("div", {
      className: "EmptyState"
    }, m("p", null, app.translator.trans('huseyinfiliz-awards.forum.empty.no_categories'))) : categories.map(category => m(CategoryCard, {
      category: category,
      award: award
    }))), award.isVotingOpen() && app.session.user ? m(VotingProgressBar, {
      votedCount: votedCount,
      totalCount: totalCategories,
      categoryIds: categoryIds,
      selectedCategoryId: selectedCategoryId,
      onCategoryChange: onCategoryChange,
      onNavigate: categoryId => {
        const element = document.getElementById(`category-${categoryId}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }) : null);
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/VotingView', VotingView);